import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Download, BadgeCheck } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDeShort } from "@/lib/date";
import { GermanDateInput } from "@/components/GermanDateInput";
import { downloadBlob } from "@/components/TraegerTemplatesTab";

export default function TraegerSealsTab() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ name: "", valid_until: "", file: null });
  const ref = useRef(null);
  const load = () => api.get("/traeger-center/seals").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const upload = async () => {
    if (!f.name.trim() || !f.file) return toast.error("Bitte Bezeichnung und Datei angeben");
    const fd = new FormData();
    fd.append("name", f.name); fd.append("valid_until", f.valid_until || ""); fd.append("file", f.file);
    try {
      await api.post("/traeger-center/seals", fd, { timeout: 60000 });
      toast.success("Siegel gespeichert");
      setF({ name: "", valid_until: "", file: null }); if (ref.current) ref.current.value = "";
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  const remove = async (s) => {
    if (!window.confirm(`„${s.name}" löschen?`)) return;
    await api.delete(`/traeger-center/seals/${s.seal_id}`);
    load();
  };
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="space-y-6" data-testid="traeger-seals">
      <div className="border border-slate-200 bg-white p-5 grid grid-cols-1 md:grid-cols-[1fr_170px_1fr_auto] gap-3 items-end">
        <label className="text-xs text-slate-600 flex flex-col">Bezeichnung<input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="z. B. AZAV-Zertifikat" className="input-tech mt-1" data-testid="seal-name" /></label>
        <label className="text-xs text-slate-600 flex flex-col">Gültig bis<GermanDateInput value={f.valid_until} onChange={(e) => setF({ ...f, valid_until: e.target.value })} className="mt-1 w-full" data-testid="seal-valid" /></label>
        <div className="text-xs text-slate-600 flex flex-col">Datei (PNG, JPG, PDF)
          <input ref={ref} type="file" accept=".pdf,.png,.jpg,.jpeg" className="hidden" onChange={(e) => setF({ ...f, file: e.target.files[0] || null })} data-testid="seal-file" />
          <button type="button" onClick={() => ref.current?.click()} className="input-tech mt-1 text-left truncate" data-testid="seal-file-pick">{f.file ? f.file.name : <span className="text-slate-400">Datei auswählen…</span>}</button>
        </div>
        <button onClick={upload} className="px-4 py-2.5 text-xs font-medium bg-slate-900 text-white hover:bg-black flex items-center gap-1.5 justify-center" data-testid="seal-upload"><Upload size={12} /> Hochladen</button>
      </div>
      <div className="border border-slate-200 bg-white divide-y divide-slate-100" data-testid="seal-list">
        {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">Noch keine Zertifizierungssiegel hinterlegt.</div>}
        {items.map((s) => {
          const expired = s.valid_until && s.valid_until < today;
          return (
            <div key={s.seal_id} className="p-4 flex items-center gap-3" data-testid={`seal-row-${s.seal_id}`}>
              <BadgeCheck size={18} className={expired ? "text-red-500" : "text-emerald-600"} />
              <div className="flex-1 min-w-0">
                <div className="text-sm text-slate-900">{s.name}</div>
                <div className={`text-[11px] ${expired ? "text-red-600" : "text-slate-500"}`}>{s.valid_until ? `${expired ? "abgelaufen am" : "gültig bis"} ${formatDeShort(s.valid_until)}` : "ohne Ablaufdatum"} · {s.filename}</div>
              </div>
              <button onClick={() => downloadBlob(`/traeger-center/seals/${s.seal_id}/file`, s.filename)} className="text-slate-500 hover:text-slate-900" data-testid={`seal-download-${s.seal_id}`}><Download size={14} /></button>
              <button onClick={() => remove(s)} className="text-slate-400 hover:text-red-600" data-testid={`seal-delete-${s.seal_id}`}><Trash2 size={14} /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
